/* eslint-disable @typescript-eslint/no-explicit-any */
import Image from 'next/image'
import { IoChevronDown } from 'react-icons/io5'
import { useLogin } from '../../hooks/useLogin'
import { GetServerSideProps } from 'next'
import { getSession } from 'next-auth/react'
import { Button } from '@heroui/react'
import { useRouter } from 'next/router'
import Head from 'next/head'

export default function LoginPage() {
  // Use the custom hook
  const {
    isOpen,
    selectedRole,
    userAnswer,
    canvasRef,
    errors,
    register,
    handleSubmit,
    toggleDropdown,
    handleSelect,
    onSubmit,
    setUserAnswer,
    roles,
  } = useLogin()
  const route = useRouter()

  return (
    <>
      <Head>
        <title>Masuk - LPPPU USU</title>
      </Head>
      <div className="w-full h-dvh flex flex-col lg:flex-row">
        <div className="hidden lg:block bg-[url('/img/banner-login.jpg')] aspect-video lg:aspect-auto w-full">
          <div className="w-full h-full bg-primary opacity-50"></div>
        </div>
        <div className="w-full flex items-center justify-center bg-white h-full rounded-t-xl lg:rounded-t-none   lg:-mt-0 z-10">
          <div className="w-full h-full   sm:flex items-center justify-center py-10 lg:py-0">
            <div className="bg-white p-4 ">
              <div className="flex flex-row sm:flex-col gap-4 items-center sm:items-start">
                {/* Logo */}
                <div className="w-20 h-20 aspect-square rounded-full flex items-center justify-center">
                  <Image
                    src={'/img/logo-usu.png'}
                    width={128}
                    height={26}
                    alt="logo-usu"
                    className="w-full h-full object-cover"
                  />
                </div>
                {/* Welcome Text */}

                <div className="py-6">
                  <p className="text-black font-black sm:text-xl pb-2">
                    Selamat Datang Kembali !
                  </p>
                  <p className="text-black font-normal sm:font-medium text-xs sm:text-sm">
                    Masuk untuk mendapatkan akses data{' '}
                    <br className="flex sm:hidden" />& informasi tak terbatas.
                  </p>
                </div>
              </div>
              {/* Form */}

              <form onSubmit={handleSubmit(onSubmit)} className="grid gap-4">
                {/* Select Role */}
                <div className="grid gap-1">
                  <div className="flex items-center gap-2">
                    <p className="text-black text-sm font-normal">
                      Masuk Sebagai
                    </p>
                    <p className="text-sm text-red-600">*</p>
                  </div>
                  <div className="w-full relative">
                    <button
                      type="button"
                      onClick={toggleDropdown}
                      className="flex items-center text-sm justify-between w-full bg-white text-black rounded-md border-2 border-primary px-3 py-3 text-left focus:outline-none"
                    >
                      {selectedRole.text}
                      <span>
                        <IoChevronDown className="w-4 h-4" />
                      </span>
                    </button>
                    {/* Dropdown Role List */}
                    {isOpen && (
                      <ul className="absolute w-full mt-2 bg-white border border-gray-300 rounded-md shadow-lg z-10">
                        {roles.map((role, index) => (
                          <li
                            key={index}
                            onClick={() => handleSelect(role)}
                            className="px-4 py-2 text-black hover:bg-primary hover:text-white cursor-pointer text-sm normal-case"
                          >
                            {role.text}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>

                {/* Identifier (NIM, NIP, Username) */}
                <div className="grid gap-1">
                  <div className="flex items-center gap-2">
                    {selectedRole.slug === 'DOSEN' ? (
                      <p className="text-black text-sm font-normal">
                        Nomor Induk Pegawai
                      </p>
                    ) : (
                      <p className="text-black text-sm font-normal">Email</p>
                    )}

                    <p className="text-sm text-red-600">*</p>
                  </div>
                  <input
                    className="text-sm text-black w-full bg-transparent focus:ring-0 focus:outline-none border-primary border-2 rounded-md px-3 py-3"
                    placeholder={
                      selectedRole.slug === 'DOSEN'
                        ? 'Masukkan Nomor Induk Pegawai'
                        : 'Masukkan Email'
                    }
                    // 1. Panggil register seperti biasa
                    {...register('identifier', { required: true })}
                    // 2. Tambahkan onInput untuk memaksa hapus spasi SECARA TOTAL (awal, tengah, akhir)
                    onInput={(e) => {
                      const target = e.target as HTMLInputElement
                      // Regex /\s/g artinya cari semua spasi dan ganti dengan kosong
                      target.value = target.value.replace(/\s/g, '')
                    }}
                  />
                  {errors.identifier && (
                    <p className="text-red-600 text-xs">
                      Identifier is required
                    </p>
                  )}
                </div>
                {/* Password */}
                <div className="grid gap-1">
                  <div className="flex items-center gap-2">
                    <p className="text-black text-sm font-normal">Kata Sandi</p>
                    <p className="text-sm text-red-600">*</p>
                  </div>
                  <input
                    type="password"
                    className="text-sm text-black w-full bg-transparent focus:ring-0 focus:outline-none border-primary border-2 rounded-md px-3 py-3"
                    placeholder="Masukkan Kata Sandi"
                    {...register('password', { required: true })}
                  />
                  {errors.password && (
                    <p className="text-red-600 text-xs">Password is required</p>
                  )}
                </div>

                {/* Captcha */}
                <div className="grid gap-1">
                  <div className="flex items-center gap-2">
                    <p className="text-black text-sm font-normal">Captcha</p>
                    <p className="text-sm text-red-600">*</p>
                  </div>
                  <div className="flex gap-3">
                    <canvas
                      ref={canvasRef}
                      width={180}
                      height={48}
                      className="border-primary border-2 rounded-md w-full"
                    />
                    <input
                      {...register('answer', { required: true })}
                      className="text-sm text-black w-full bg-transparent focus:ring-0 focus:outline-none border-primary border-2 rounded-md px-3 py-3"
                      placeholder="Jawaban"
                      value={userAnswer}
                      onChange={(e) => setUserAnswer(e.target.value)}
                    />
                  </div>
                  {errors.answer && (
                    <p className="text-red-600 text-xs">Answer is required</p>
                  )}
                </div>

                <div className="flex justify-end text-primary ">
                  <Button
                    variant="light"
                    color="primary"
                    onPress={() => route.push('/forgot-password')}
                  >
                    <p>Lupa Kata Sandi?</p>
                  </Button>
                </div>
                <button
                  type="submit"
                  className="text-white bg-primary w-full rounded-md py-3 font-semibold hover:bg-primary-dark"
                >
                  Masuk
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const session: any = await getSession(context)

  // Redirect berdasarkan role
  // Jika sudah login, redirect sesuai role
  if (session?.user) {
    const role = session.user.role
    return {
      redirect: {
        destination:
          role === 'ADMIN'
            ? '/dashboard-admin'
            : role === 'DOSEN'
              ? '/dashboard-dosen'
              : '/',
        permanent: false,
      },
    }
  }

  // Jika role tidak dikenali, redirect ke login
  return {
    props: {},
  }
}
